<template>
  <m-geo-box geo-option="metroArea">
    <m-geo-select :geoType="10" :changeGeoType="10"></m-geo-select>
  </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MGeoSelect from '@/components/geo/MGeoSelect'
  export default {
    components: {
      MGeoBox,
      MGeoSelect
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/GeoMetroArea.vue